export default width => width === 'xs' || width === 'sm' || width === 'md'
